import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import UserView from './Components/UserView';
import { withRouter } from 'react-router-dom';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../redux/reducers/savedVersions';

import {
  toggleSaveEditPopup,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';

import { selectedContentItem, getAllThinkTools, getAllThinkToolsAndJournals } from '../redux/selectors';

import {
  getTeamMembersFullRequest,
} from '../redux/reducers/teamMembersFull';
import RolloutView from './Components/RolloutView';
import { selectUserPrograms } from '../redux/reducers/userProgramsFull';

const Rollouts = ({ view }) => <RolloutView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  coachFull: state.teamMembersFullReducer
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  setProject: int => dispatch(selectUserPrograms(int)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      console.log('ROLLOUT MOUNTED',this.props.match.params.projectId ),
      this.props.setProject(parseInt(this.props.match.params.projectId))
    },
    componentWillReceiveProps(nextProps) {
      
    },
  }),
)(Rollouts);

Rollouts.propTypes = {
  view: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Screens/Rollouts.jsx